require('public/css/search.scss');
const get = require('lodash/get');
const isNil = require('lodash/isNil');
var isLoadingFacets = false;

const {
	getFacetValuesFromDom
} = require('public/js/components/search-facets');

const {
	getSearchResultsCatalog
} = require('public/js/catalog-helper');

const partTypeFilterHelpers = require('../templates/modules/part_type_filter/utils');

let searchFacetParams = []; // set after onReady
const util = require('./plugin/lib/util');
const { trackImpressionsEvent, trackCategoryListEvent } = require('public/js/lib/adobe-dtm-helper');
const vehicleParams = ['year', 'make', 'model'];
const search = {
	type: 'search',
	category: '',
	catalog_type_helper: 'refresh-assemblies',
	groupAndSubgroup: '' // This is specific to accessories pages, but does not hurt regular search
};
const moduleSearchType = rp$('.search-listing-module').data('search-type');
const searchType = moduleSearchType ? moduleSearchType : search.type;
const subSearchType = rp$('.search-listing-module').data('sub-search-type') ?? null;
const cfcListingPage = rp$('.cfc-listingpage').length;
const searchModule = rp$('.search-listing-module');

search.getAvailableSearchFacetQueryNames = function() {
	const facets = Array.from(
		document.querySelectorAll('.search-facets-module .facet-wrapper')
	);

	return facets.map((facet) => facet.getAttribute('data-query-name'));
};

search.getSearchResults = function (changedField, params) {
	let historyUrl;
	const categoryData = searchModule.data('category');
	const subcategoryData = searchModule.data('subcategory');
	let category = params.category ? params.category : categoryData;

	if (cfcListingPage && categoryData) {
		let categoryUrl = subcategoryData ? `${categoryData}/${subcategoryData}` : categoryData;
		category = categoryUrl;
	}

	// Ensure groupAndSubgroup is set for accessories pages before building URL
	if (!search.groupAndSubgroup) {
		const groupAndSubgroup = window.location.pathname.split('/accessories-')[1];
		if (groupAndSubgroup) {
			search.groupAndSubgroup = groupAndSubgroup;
		}
	}

	if (changedField !== 'history') {
		historyUrl = search.buildHistoryUrl(params);
	}
	if (rp_app.query.all().ptid) {
		params.ptid = rp_app.query.all().ptid;
	}
	
	if (globalThis.__DISABLE_SEARCH_HISTORY_HANDLER || (searchType === 'search' && subSearchType !== 'standard-search')) {
		rp_app.location.redirect(historyUrl);
		return;
	}

	const pUrl = rp_app.location.pathname.replace(/^\//, '');
	params.pUrl = pUrl;

	Object.keys(params).forEach(key => {
		if (Array.isArray(params[key])) {
			params[key] = params[key].join(',');
		}
	});

	rp$(document).trigger('searchResults:request');
	$ajax({
		method: 'GET',
		dataType: 'json',
		data: params,
		url: this.buildFetchUrl(category),
		error: (jqxhr, textStatus) => {
			if (textStatus === 'timeout') {
				this.tryCount++;
				if (this.tryCount <= this.maxRetry) {
					$ajax(this);
					return;
				}
			}

			rp$(document).trigger('searchResults:error');
		},
		success: (response, status) => {
			if(status !== 'success') { return; }

			// Handle the single product redirect to product page case
			if (response && response.redirect_url) {
				rp_app.location.redirect(response.redirect_url);
				return;
			} else if (!isNil(historyUrl)) {
				try {
					if(searchType === 'dynamic_seo') {
						window.history.pushState(params, '', historyUrl);
					} else {
						window.history.pushState({}, '', historyUrl);
					}
				}
				catch (e) {/* TODO: For now, ignoring IE9 and below.. revisit when we do full filtering sidebar */}
				historyUrl = null;
			}

			// DTB-402 Count this as a page view & featured products impression
			// If analytics are enabled, count this as another page view
			if (rp_app.env.google_analytics_enabled) {
				window.tracking.ec.products = response.tracking_products;  // Set tracking products so they can be used by Enhanced Ecommerce Product Impressions if enabled
				rp_app.track.track_pageview_all_trackers();
			}

			this.handleAdobeDTMTracking(searchType, response.tracking_products);

			rp$(document).trigger('searchResults:response', response);
		},
		complete: () => {
			isLoadingFacets = false;
		}
	});
};

search.buildFetchUrl = function (new_category='') {
	switch (searchType) {
		case 'dynamic_seo':
			return '/ajax/dynamic-seo-search';
		case 'cfc_search': {
			return cfcListingPage 
				? `/ajax/category-listing/${new_category.length === 0 ? this.category : new_category}` 
				: `/ajax/category-search/${new_category.length === 0 ? this.category : new_category}`;
		}
		case 'vehicle-picker-category':
			return `/ajax/vp-category-search/${this.category}--${this.subcategory}`;
		case 'accessories':
			return `/ajax/accessories-${this.groupAndSubgroup}`;
		default:
			return '/ajax/search';
	}
};

search.buildHistoryUrl = function (requestParams) {
	Object.keys(requestParams).forEach(key => {
		if (Array.isArray(requestParams[key])) {
			requestParams[key] = requestParams[key].join(',');
		}
	});

	let historyUrl;
	let base = rp$('base').attr('href');

	if (!base || typeof base === 'string') {
		base = rp_app.location.getBase();
	}
	const baseUrl = base;

	// Decode URL parameters that come already encoded from the browser URL bar
	// to prevent triple encoding when rp$.param() processes them later
	const rawCurrentUrlParams = rp_app.query.all();
	
	const currentUrlParams = {};
	Object.keys(rawCurrentUrlParams).forEach((key) => {
		currentUrlParams[key] = decodeURIComponent(rawCurrentUrlParams[key]);
	});
	
	let currentPath;

	if (searchType === 'vp-picker-category' ) {
		currentPath = requestParams.page_url;
		const filterParam = search.buildDynamicSeoFilterParam(requestParams);
		historyUrl = util.addTrailingSlash(baseUrl) + currentPath;
		if (filterParam) {
			historyUrl += '/' + filterParam;
		}

		// Ensure we keep search facet query params around
		const facetParams = searchFacetParams.reduce((accumulator, searchFacetParam) => {
			accumulator[searchFacetParam] = requestParams[searchFacetParam];
			return accumulator;
		}, {});

		// Ensure we keep any addition filter params around
		const partTypeFilters = partTypeFilterHelpers.getAdditionalFilterValuesFromDom() || {};
		const params = {
			...facetParams,
			...partTypeFilters,
		};

		// Create a clean targetParams object that only contains the current requestParams
		// This ensures deselected filters are removed from the URL
		const targetParams = {...params};

		historyUrl += `?${rp$.param(targetParams)}`;
	} else if(searchType === 'cfc_search') {
		currentPath = rp_app.location.pathname.replace(/^\//, '');

		// Create a clean targetParams object that only contains the current requestParams
		// This ensures deselected filters are removed from the URL
		const targetParams = {...requestParams};

		if (cfcListingPage) {
			delete targetParams['identifier'];
			delete targetParams['use_cfc'];
			delete targetParams['search_str'];
			delete targetParams['page_url'];
			delete targetParams['page_id'];
			delete targetParams['catalog_type'];
			delete targetParams['facetValues'];
		}

		if(requestParams.category) {
			currentPath = currentPath.split('/');
			const category = requestParams.category;
			delete requestParams.category;
			
			historyUrl = baseUrl + '/' + currentPath[0] + '/' + (cfcListingPage ? '' : currentPath[1] + '/') + category + '?' + rp$.param(targetParams);
		} else {
			historyUrl = baseUrl +'/'+ currentPath +'?'+ rp$.param(targetParams);
			delete targetParams['use_cfc'];
		}
	} else if (searchType === 'dynamic_seo' || requestParams.search_str === '') {
		currentPath = (requestParams.page_url) ? requestParams.page_url : rp_app.location.pathname.replace(/^\//, '');
		
		if (searchType === 'search'){
			delete requestParams['identifier'];
			delete requestParams['use_cfc'];
		}

		const filterParam = search.buildDynamicSeoFilterParam(requestParams);
		historyUrl = util.addTrailingSlash(baseUrl) + currentPath;
		
		// Create a clean targetParams object that only contains the current requestParams
		// This ensures deselected filters are removed from the URL
		const targetParams = {...requestParams};

		if (filterParam) {
			historyUrl += '/' + filterParam;
		}

		delete targetParams['make'];
		delete targetParams['year'];
		delete targetParams['model'];
		delete targetParams['identifier'];
		delete targetParams['facetValues'];
		delete targetParams['use_cfc'];
		delete targetParams['page_url'];
		delete targetParams['page_id'];
		delete targetParams['catalog_type'];
		
		if (searchFacetParams && searchFacetParams.length > 0) {
			searchFacetParams.forEach(facetParam => {
				delete targetParams[facetParam];
			});
		}
		
		const cleanParams = {};
		Object.keys(targetParams).forEach(key => {
			const value = targetParams[key];
			if (value !== null && value !== undefined && value !== '') {
				cleanParams[key] = value;
			}
		});

		historyUrl += '?' + rp$.param(cleanParams);
	} else if (!window.__IS_WEBSTORE_PLUGIN) {
		currentPath = rp_app.location.pathname.replace(/^\//, '');
		// Create a clean targetParams object that only contains the current requestParams
		// This ensures deselected filters are removed from the URL
		var targetParams = {...requestParams};
		delete targetParams['identifier'];
		delete targetParams['use_cfc'];

		historyUrl = baseUrl +'/'+ currentPath +'?'+ rp$.param(targetParams);
	} else {
		currentPath = rp_app.location.pathname.replace(/^\//, '');
		delete requestParams['identifier'];
		delete requestParams['use_cfc'];
		const decodedStr = decodeURIComponent(currentUrlParams.path);
		const currentParamsObject = {};
		if (decodedStr.includes('?')) {
			const currentParams = new URLSearchParams(decodedStr.split('?')[1]);
			currentParams.forEach((value, key) => {
				currentParamsObject[key] = value;
			});
		}
		if(requestParams.make === '' && requestParams.model !== '' && currentParamsObject.make) {
			requestParams.model = '';
		}
		// Create a clean targetParams object that only contains the current requestParams
		// This ensures deselected filters are removed from the URL
		let targetParams = {...requestParams};
		currentUrlParams.path = decodedStr.split('?')[0] + '?' + rp$.param(targetParams);

		historyUrl = baseUrl +'/'+ currentPath +'?'+ rp$.param(currentUrlParams);
	}

	return historyUrl;
};

search.getDseoFilterParamsFromDom = function() {
	const params = {};
	vehicleParams.forEach((vehicleParam) => {
		const $option = rp$(`.refine-search-form .refine-select[data-refine=${vehicleParam}] option[selected]`);
		if ($option.length > 0) {
			params[vehicleParam] = $option.attr('value');
		}
	});

	return params;
};

search.buildDynamicSeoFilterParam = function (requestParams) {
	const paramArr = [];
	const domFilterParams = search.getDseoFilterParamsFromDom();
	vehicleParams.forEach((vehicleParam) => {
		if (requestParams[vehicleParam]) {
			paramArr.push(requestParams[vehicleParam]);
		} else if (domFilterParams[vehicleParam] && !(typeof requestParams[vehicleParam] === 'string')) {
			// If filter not provided, try to infer from the DOM
			paramArr.push(domFilterParams[vehicleParam]);
		}
	});

	return paramArr.join('-');
};

search.handleHistoryChange = function(evt) {
	var params;
	var args = rp_app.query.all(rp_app.location.href);

	/* If we don't have arguments from the URL and we're in a dynamic SEO Context,
	 * check to see if we have arguments stored in the state
	.*-----------------------------------------*/
	if ((search.type === 'dynamic_seo') && (typeof evt.state === 'object') && (evt.state !== null)) {
		args.make = evt.state.make;
		args.model = evt.state.model;
		args.year = evt.state.year;
		args.page_id = evt.state.page_id;
		args.page_url = evt.state.page_url;

		if(evt.state.redirect_url) {
			rp_app.location.redirect(evt.state.redirect_url);
			return;
		}
	}

	params = {
		page: args.page,
		search_str: (args.search_str) ? decodeURIComponent(args.search_str) : '',
		year: args.year || '',
		make: args.make || '',
		model: args.model || '',
		page_id: args.page_id || '',
		catalog_type: search.getSelectedCategoryCatalogType()
	};
	if (!isNaN(parseInt(args.ptid, 10))) {
		params.ptid = decodeURIComponent(args.ptid);
	}
	searchFacetParams.forEach((facet) => {
		if (args[facet]) {
			params[facet] = decodeURIComponent(args[facet]);
		}
	});

	search.getSearchResults('history', params);
};

search.hookPageHistory = function () {
	window.addEventListener('popstate', this.handleHistoryChange);

	/* For Dynamic SEO pages, treat the root page as a static page. Save the URL to be called when we navigate back to it
	.*-----------------------------------------*/
	if(searchType === 'dynamic_seo') {
		try {
			window.history.replaceState({
				redirect_url: rp_app.location.href
			}, '', rp_app.location.href);
		}

		catch (e) {/* TODO: For now, ignoring IE9 and below.. revisit when we do full filtering sidebar */}
	}
};

search.handlePageChange = function(pageNum) {
	const args = rp_app.query.all(rp_app.location.href);
	const partTypeFilters = partTypeFilterHelpers.getAdditionalFilterValuesFromDom();
	let vpCategorySearchParams = {};
	const facets = search.getAvailableSearchFacetQueryNames();

	// Get current facet selections from DOM to preserve them during pagination
	const searchFacets = require('./components/search-facets');
	const { facetValues: currentFacetValues } = searchFacets.getFacetValuesFromDom(false);

	if (searchType === 'cfc_search') {
		const vehicleFilterParams = search.getDseoFilterParamsFromDom();
		let params = {
			page: pageNum,
			...partTypeFilters,
		};
		
		if(cfcListingPage) {
			facets.forEach((facet) => {
				if (args[facet]) {
					params[facet] = decodeURIComponent(args[facet]);
				}
			});
		}

		// Include current facet selections from DOM
		Object.keys(currentFacetValues).forEach(facetName => {
			if (currentFacetValues[facetName] && Array.isArray(currentFacetValues[facetName])) {
				params[facetName] = currentFacetValues[facetName];
			}
		});

		params = {...params, ...vehicleFilterParams};
		search.getSearchResults('page', params);

		return;
	} else if (searchType === 'vehicle-picker-category') {
		vpCategorySearchParams = this.getVPVehicleParams();
	} else if (searchType === 'accessories') {
		const params = {
			page: pageNum,
			catalog_type: search.getSelectedCategoryCatalogType(),
			...partTypeFilters,
		};

		Object.keys(currentFacetValues).forEach((facetName) => {
			if (currentFacetValues[facetName] && Array.isArray(currentFacetValues[facetName])) {
				params[facetName] = currentFacetValues[facetName];
			}
		});

		search.getSearchResults('page', params);
		return;
	} else if (searchType === 'dynamic_seo'){
		const pageId = rp$('.pagination-label').data('pageid');
		const pageUrl = rp$('.pagination-label').data('pageurl');
		const vehicleFilterParams = search.getDseoFilterParamsFromDom();

		const params = {
			page: pageNum,
			page_id: pageId,
			page_url: pageUrl,
			catalog_type: search.getSelectedCategoryCatalogType(),
			...partTypeFilters,
			identifier: {
				usePreviousFacets: true
			},
		};

		facets.forEach((facet) => {
			if (args[facet]) {
				params[facet] = decodeURIComponent(args[facet]);
			}
		});

		// Include current facet selections from DOM
		Object.keys(currentFacetValues).forEach(facetName => {
			if (currentFacetValues[facetName] && Array.isArray(currentFacetValues[facetName])) {
				params[facetName] = currentFacetValues[facetName];
			}
		});

		const updatedParams = {...params, ...vehicleFilterParams, ...partTypeFilters };
		search.getSearchResults('page', updatedParams);
		return;
	}

	const params = {
		page: pageNum,
		search_str: (args.search_str) ? decodeURIComponent(args.search_str) : '',
		year: args.year || vpCategorySearchParams.year || '',
		make: args.make || vpCategorySearchParams.make || '',
		model: args.model || vpCategorySearchParams.model || '',
		catalog_type: search.getSelectedCategoryCatalogType(),
		...partTypeFilters,
		identifier: {
			usePreviousFacets: true
		},
	};
	if (!isNaN(parseInt(args.ptid, 10))) {
		params.ptid = decodeURIComponent(args.ptid);
	}
	searchFacetParams.forEach((facet) => {
		if (args[facet]) {
			params[facet] = decodeURIComponent(args[facet]);
		}
	});

	// Include current facet selections from DOM
	Object.keys(currentFacetValues).forEach(facetName => {
		if (currentFacetValues[facetName] && Array.isArray(currentFacetValues[facetName])) {
			params[facetName] = currentFacetValues[facetName];
		}
	});

	search.getSearchResults('page', params);
};

search.getSelectedCategoryCatalogType = function() {
	let selectedCatalogType = 'parts';

	const activeCategoryElements = rp$.find('.active-cat');
	if (Array.isArray(activeCategoryElements) && activeCategoryElements.length) {
		const activeCategory = activeCategoryElements[0];
		const closestCardParent = activeCategory.closest('.card');

		if (closestCardParent) {
			const cardParentClasses = closestCardParent.classList;

			if (cardParentClasses && cardParentClasses.contains('accessories')) {
				selectedCatalogType = 'accessories';
			}
		}
	}

	return selectedCatalogType;
};

search.getVPVehicleParams = function() {
	let params = {};
	let vpGarage =  rp$('.vp-category-garage');

	if (vpGarage && vpGarage.length) {
		vpGarage = vpGarage[0];
		params.year = vpGarage.getAttribute('data-vehicle-year');
		params.make = vpGarage.getAttribute('data-vehicle-make');
		params.model = vpGarage.getAttribute('data-vehicle-model');
	}

	return params;
};

search.handleAdobeDTMTracking = function(searchType, products = null) {

	if (!get(window, 'digitalData.newEvent')) {
		return;
	}

	let adobeDTMProducts = null;

	// Adobe DTM requires product prices to be in string form
	if (Array.isArray(products)) {
		adobeDTMProducts = products.map(product => {
			product.price = String(product.price);
			return product;
		});
	}
	if (searchType === 'accessories' || searchType === 'cfc_search') {
		const productRows = rp$('.catalog-product.marketplace-product');
		// Track Adobe DTM category page view
		if (productRows.length) {

			if (adobeDTMProducts) {
				window.digitalData.products.listing = adobeDTMProducts;
			}
			trackCategoryListEvent();
		}
	} else {
		// Regular searches & dseo searches can be treated as impression events
		if (adobeDTMProducts) {
			window.digitalData.products.impressions = adobeDTMProducts;
		}
		trackImpressionsEvent();
	}
};

search.getCategoryId = function () {
	return parseInt(rp$('.catalog-products').data('category'));
};

search.prepareSearchResults = function(use_cfc = false) {
	searchFacetParams = search.getAvailableSearchFacetQueryNames();
	const moduleSearchType = rp$('.search-listing-module').data('search-type');
	if(moduleSearchType) {
		search.type = moduleSearchType;
	}

	search.handleAdobeDTMTracking(search.type);
	search.setupStickyModules();

	const moduleCategory = rp$('.search-listing-module').data('category');
	if (moduleCategory) {
		search.category = moduleCategory;
	}

	const moduleSubcategory = rp$('.search-listing-module').data('subcategory');
	if (moduleSubcategory) {
		search.subcategory = moduleSubcategory;
	}

	if (!search.groupAndSubgroup) {
		const groupAndSubgroup = window.location.pathname.split('/accessories-')[1];
		if (groupAndSubgroup) {
			search.groupAndSubgroup = groupAndSubgroup;
		}
	}

	const $partTypeFilter = rp$('.part-type-filter-form');
	if ($partTypeFilter.length > 0) {
		if (searchModule.length > 0) {
			rp$(document).off('changeAdditionalFilters', '.part-type-filter-form');
			rp$(document).on('changeAdditionalFilters', '.part-type-filter-form', function handleAdditionalFilterChange(evt, filters) {
				evt.stopPropagation();
				
				if (isLoadingFacets) {
					return;
				}
				
				let dataUrlRedirect = filters?.dataUrlRedirect ?? null;
				
				if (!dataUrlRedirect) {
					const $selectedOption = rp$('.part-type-filter-form .select-filter option:selected');
					const $selectedRadio = rp$('.part-type-filter-form input[name*=part_type_value]:checked');
					dataUrlRedirect = $selectedOption.length > 0 
						? $selectedOption.attr('data-url-redirect') 
						: ($selectedRadio.length > 0 ? $selectedRadio.attr('data-url-redirect') : null);
				}
				
				const urlType = dataUrlRedirect ? partTypeFilterHelpers.getUrlType(dataUrlRedirect) : null;
				if (urlType === partTypeFilterHelpers.URL_TYPE_RELATIVE || urlType === partTypeFilterHelpers.URL_TYPE_ABSOLUTE) {
					partTypeFilterHelpers.showSpinner();
					rp_app.location.redirect(dataUrlRedirect);
					return;
				}
				
				partTypeFilterHelpers.showSpinner();
				
				const partTypeFilters = filters || partTypeFilterHelpers.getAdditionalFilterValuesFromDom();
				
				const updatedParams = {};
				Object.keys(partTypeFilters).forEach(key => {
					const value = partTypeFilters[key];
					if (value !== null && value !== undefined && value !== '') {
						updatedParams[key] = value;
					}
				});
				
				const historyUrl = search.buildHistoryUrl(updatedParams);
				if (historyUrl) {
					rp_app.location.redirect(historyUrl);
					return;
				}
				
				isLoadingFacets = true;
				
				search.getSearchResults('', updatedParams);
			});
		}
	}

	rp$('.part-type-filter-form .select-filter').on('change', function(e) {
		e.preventDefault();
		var optionSelected = rp$('option:selected', this);
		const url = optionSelected.attr('data-url-redirect');
		if (url) {
			rp_app.location.redirect(url);
		}
	});

	rp$('.part-type-filter-form .radio-group-filter').on('change', function(e) {
		e.preventDefault();
		var optionSelected = rp$('input:checked', this);
		const url = optionSelected.attr('data-url-redirect');
		if (url) {
			rp_app.location.redirect(url);
		}
	});

	const $filtersModule = rp$('.search-filters-module .refine-search-form');
	if ($filtersModule.length > 0)  {
		$filtersModule.off('changeFilters');
		$filtersModule.on('changeFilters', function handleFilterChange(evt, changedField, filters) {
			// Factor existing facets into search
			const facetParams = getFacetValuesFromDom();
			const partTypeFilters = partTypeFilterHelpers.getAdditionalFilterValuesFromDom();
			const updatedParams = { ...filters, ...facetParams, ...partTypeFilters };
			search.getSearchResults(changedField, updatedParams);
		});
	}

	const $facetsModule = rp$('.search-facets-module');
	if ($facetsModule.length > 0) {
		if (use_cfc) {
			$facetsModule.on('selectedFacetBucketsChanged', function handleSelectedBucketsChange(e, queryParams) {
				search.catalog_type_helper = search.getCategoryId() ? 'catalog-c' : 'refresh-assemblies';
				// Factor existing vehicle filter params into search
				const partTypeFilters = partTypeFilterHelpers.getAdditionalFilterValuesFromDom();
				const updatedParams = { ...queryParams, ...partTypeFilters };
				getSearchResultsCatalog('', updatedParams);
			});
		} else {
			$facetsModule.on('selectedFacetBucketsChanged', function handleSelectedBucketsChange(e, queryParams) {
				// Factor existing vehicle filter params into search
				const vehicleFilterParams = search.getDseoFilterParamsFromDom();
				const partTypeFilters = partTypeFilterHelpers.getAdditionalFilterValuesFromDom();
				const updatedParams = { ...queryParams, ...vehicleFilterParams, ...partTypeFilters };
				if(!isLoadingFacets) {
					isLoadingFacets = true;
					const category = searchModule.data('category');
					const subcategory = searchModule.data('subcategory');

					if(cfcListingPage && category) {
						const categoryUrl = subcategory ? `${category}/${subcategory}` : category;
						updatedParams['category'] = categoryUrl;
					}
					search.getSearchResults('', updatedParams);
				}
			});
		}
	}
};

search.setupStickyModules = function() {
	const layoutSearch = document.getElementById('layout_search');
	if (!layoutSearch) return;

	const stickyModules = layoutSearch.querySelectorAll('.page-builder-layout-module--sticky');
	if (!stickyModules.length) return;

	const stickyWrapper = stickyModules[0].closest('.page-builder-layout-column-wrap');
	if (stickyWrapper) {
		stickyWrapper.style.setProperty('--sticky-modules-wrapper-height', '100%');
	}

	const offset = { top: 10, bottom: 10 };
	const gap = 20;
	const totalGaps = (stickyModules.length - 1) * gap;
	let totalFixedHeight = 0;

	const modulesData = Array.from(stickyModules).map(module => {
		const scrollableChild = module.querySelector('.module-scrollable');
		if (! scrollableChild) totalFixedHeight += module.offsetHeight;
		return { module, scrollableChild };
	});

	const scrollables = modulesData.filter(m => m.scrollableChild);
	const scrollableCount = scrollables.length;
	const viewportHeight = window.innerHeight || 1;
	const extraTopHeight = 90;
	const extraModuleHeight = scrollableCount ? extraTopHeight / scrollableCount : 0;
	const remainingHeightVh = ((viewportHeight - (totalFixedHeight + totalGaps + offset.top + offset.bottom)) / viewportHeight) * 100;
	const scrollableHeightVh = scrollableCount ? remainingHeightVh / scrollableCount : 0;

	let containerBackgroundColor = 'white';
	if (stickyWrapper) {
		const backgroundColor = getComputedStyle(stickyWrapper).backgroundColor;
		if (backgroundColor && backgroundColor !== 'rgba(0, 0, 0, 0)' && backgroundColor !== 'transparent') {
			containerBackgroundColor = backgroundColor;
		}
	}

	let currentOffset = offset.top;
	for (const { module, scrollableChild } of modulesData) {
		module.style.setProperty('--sticky-module-top', `${currentOffset}px`);
		module.style.setProperty('--sticky-module-top-extra', `${extraTopHeight}px`);

		if (scrollableChild) {
			scrollableChild.style.setProperty('--sticky-module-height', `${scrollableHeightVh}vh`);
			scrollableChild.style.setProperty('--sticky-module-extra', `${extraModuleHeight}px`);
		}

		const moduleBg = getComputedStyle(module).backgroundColor;
		if (!moduleBg || moduleBg === 'rgba(0, 0, 0, 0)' || moduleBg === 'transparent') {
			module.style.backgroundColor = containerBackgroundColor;
		}

		currentOffset += module.offsetHeight + gap;
	}

	const containerWrap = stickyModules[0].closest('.container-wrap.container-fluid');
	if (stickyWrapper && containerWrap) {
		const stickyWrapperHeight = containerWrap.offsetHeight > window.innerHeight ? containerWrap.offsetHeight : '100%';
		stickyWrapper.style.setProperty('--sticky-modules-wrapper-height', `${stickyWrapperHeight}`);
	}
};

if (!window.__DISABLE_SEARCH_HISTORY_HANDLER) {
	search.hookPageHistory();
	rp$(document).off('searchResults:pageChange');
	rp$(document).on('searchResults:pageChange', function handlePageChange(evt, pageNum) {
		evt.preventDefault();
		search.handlePageChange(pageNum);
	});
}

module.exports = search;
